import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AzureUploadFileService } from '../../../../services/lookup/azure-upload-file.service';
import { Guid } from 'guid-typescript';
import { AzureFileModel } from '../../../../models/files/azure-file.model';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-video-loader',
  templateUrl: './video-loader.component.html',
  styleUrls: ['../loader.scss']
})
export class VideoLoaderComponent implements OnDestroy {
  @Input()
  public formGroup: FormGroup;
  @Input()
  public name: string;
  @Input()
  public label: string;
  @Input() public readOnly: boolean = false;
  @Input() public maxVideoDuration: number = 60;
  private subscription: Subscription = new Subscription();
  public apiURL: string = localStorage.getItem('apiurl');

  @Output() public valueChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('videoLoaderInputRef') public videoLoaderInputRef: ElementRef;

  constructor(
    private toastrService: ToastrService,
    private uploadService: AzureUploadFileService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onFileDropped(fileList: FileList): void {
    if (this.readOnly) {
      return;
    }
    if (fileList && fileList.length) {
      this.uploadAttachment(fileList[0]);
    } else {
      return;
    }
  }

  public fileBrowseHandler(event: Event): void {
    if (event && (event.target as HTMLInputElement).files[0]) {
      this.uploadAttachment((event.target as HTMLInputElement).files[0]);
    } else {
      return;
    }
  }

  private uploadAttachment(file: File): void {
    if (file) {
      const fileNameSplitArray = file.name.split('.');
      const extension = fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase();
      if (extension !== 'mov' && extension !== 'mp4') {
        this.toastrService.warning('File type must be MOV or MP4');
        return;
      }
      if (file.size > 104857600) {
        this.toastrService.warning('Size of video can not be bigger than 100Mb');
        return;
      }
      const video = this.document.createElement('video');
      video.preload = 'metadata';
      video.src = URL.createObjectURL(file);
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        if (video.duration > +this.maxVideoDuration) {
          this.toastrService.warning(`Duration of video can not be bigger than ${Math.floor(this.maxVideoDuration / 60)} minute`);
          return;
        }
        const name = `${Guid.create()}.${extension}`;
        const reader = new FileReader();
        reader.onload = this.handleReaderLoaded.bind(this, name);
        reader.onerror = this.onReaderError.bind(this);
        reader.readAsArrayBuffer(file); //for IE11 support
      };
    }
  }

  private onReaderError(error): void {
    this.toastrService.error(`Error: ${error}`);
  }

  private handleReaderLoaded(fileName: string, event: ProgressEvent): void {
    let binary = '';
    const bytes = new Uint8Array(((event.target as FileReader).result as ArrayBuffer));
    const length = bytes.byteLength;
    for (let i = 0; i < length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64 = btoa(binary);
    const azure: AzureFileModel = {
      file: base64,
      name: fileName,
      folder: 'attachments'
    };
    this.subscription.add(
      this.uploadService.addModel(azure).subscribe((response) => {
        if (response) {
          const control = this.formGroup.get(this.name);
          if (control.value) {
            //this.deletePrevious(control.value);
          }
          control.setValue(`${this.apiURL}/AzureFileStorage/attachments/${response.name}`);
          this.videoLoaderInputRef.nativeElement.value = null;
          this.valueChanged.emit(response.name);
        }
      })
    );
  }

  private deletePrevious(url: string): void {
    const urlArray = url.split('/');
    const fileName = urlArray[urlArray.length - 1];
    this.subscription.add(
      this.uploadService.deleteModel(fileName).subscribe()
    );
  }
}
